var map = {
	"./aparthotelclub/ic_edit.png": 82794,
	"./beachful/ic_edit.png": 7750,
	"./castlepedia/ic_edit.png": 28372,
	"./cocktayl/ic_edit.png": 12152,
	"./ic_edit.png": 11346,
	"./luxresortclub/ic_edit.png": 82989,
	"./parkful/ic_edit.png": 80975,
	"./prefabworld/ic_edit.png": 52232,
	"./rooftopclub/ic_edit.png": 45928,
	"./spaclub/ic_edit.png": 2110,
	"./worldcasino/ic_edit.png": 76217,
	"./zoopedia/ic_edit.png": 82858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73030;